<template>
  <div>
    <div id="myTopnav" class="topNav cust_card mt-0 bg-staticCol hover:shadow-md rounded-none" style="overflow: visible !important;">
      <div class="menu_iconss bg-staticCol justify-between">
        <div class="dashboard_menus d_menu_icon flex items-center">
          <img v-if="mobileView"
              @click.stop="smallViewOpenDrawer2()"
              height="20px"
              class="mr-8 cursor-pointer ml-0"
              width="24px"
              src="@/assets/images/svg/menu-icon.svg"
              alt=""
            />
          <img v-if="!mobileView"
              @click.stop="smallViewOpenDrawer()"
              height="20px"
              class="mr-8 cursor-pointer ml-2"
              width="24px"
              src="@/assets/images/svg/menu-icon.svg"
              alt=""
            />
          <span @click="$router.push({ name: 'Dashboard' })">
            <img class="cursor-pointer" src="@/assets/logo.png" height="120px" width="120px" />
          </span>
          <div v-if="EmpObj.isSAdmin && !extraSmall" style="width:300px;" id="ffffff" class="serach_box" :style="!showGlobalSearch ? `background: ${color123}` : `background: ${color123}`">
            <GlobalSearch @showGlobalSearch1="showGlobalSearch1"/>
          </div>
        </div>
        <div class="flex items-center">
          <img v-if="extraSmall"
            @click.stop="openDialog1()"
            height="20px"
            class="mr-8 cursor-pointer ml-0"
            width="24px"
            src="@/assets/images/svg/white-search.svg"
            alt=""
          />
          <div class="pr-3" v-if="!mobileView">
            <div class="p-2 items-center grid text-center">
              <div class="flex items-center justify-center">
                <p class="firstNameCss text-white capitalize">{{ EmpObj.firstName }} {{ EmpObj.lastName }}</p>
                <img v-if="EmpObj.isSAdmin" height="20px" width="20px" src="@/assets/images/svg/superadmin.svg" class="pl-1">
              </div>
              <p class="emailCss text-white">({{ EmpObj.emailAddress }})</p>
            </div>
          </div>
          <div class="text-center right-2 relative">
            <div class="cursor-pointer" @click.stop="isOpenValue()">
              <div :class="mobileView ? 'h-10 w-10' : 'h-10 w-10'" class="rounded-full border border-staticCol " dark>
                <img class="rounded-full h-10 w-10" src="@/assets/images/svg/user-color.svg">
              </div>
            </div>
            <div v-if="isOpen" class="top-12 right-0 fixed" >
            <div class="autoPadding px-0 pt-0" v-click-outside="onClickOutside">
              <div class="cust_card bg-white w-52 border border-gray-200">
                <div class="dividerLight"></div>
                <!-- <div class="firstNameCss p-3 text-text1 font-semibold  cursor-pointer flex items-center hover:bg-blue-100" @click="$router.push({ name: 'Dashboard' });isOpen = false">
                  <i class="fas fa-home h-5 w-5 text-primary"></i>
                  <p class="pl-4">Dashboard</p>
                </div>
                <div class="dividerLight"></div> -->
                <div class="text-center" v-if="mobileView">
                  <div class="p-2 items-center grid text-center">
                    <div class="flex items-center justify-center">
                      <p class="heading-5 text-text2 capitalize font-semibold">{{ EmpObj.firstName }} {{ EmpObj.lastName }}</p>
                      <img v-if="EmpObj.isSAdmin" height="20px" width="20px" color="black" src="@/assets/images/svg/superadmin copy.svg" class="pl-1">
                    </div>
                    <p class="heading-7 text-text2 font-semibold">({{ EmpObj.emailAddress }})</p>
                  </div>
                </div>
                <div v-if="mobileView" class="dividerLight"></div>
                <div v-if="EmpObj.isSAdmin" class="firstNameCss p-3 text-text1 font-semibold  cursor-pointer flex items-center hover:bg-blue-100" @click="$router.push({name: 'StaffDetail', params: {userDetailId: EmpObj.userDetailId}});isOpen = false">
                  <i class="fa-solid fa-house-user h-5 w-5 text-primary"></i>
                  <p class="pl-4 heading-5">Profile</p>
                </div>
                <div class="dividerLight"></div>
                <div class="firstNameCss p-3 text-text1 font-semibold hover:bg-blue-100 cursor-pointer flex items-center" @click="LogOut()">
                  <i class="fas fa-sign-out-alt h-5 w-5 text-primary"></i>
                  <p class="pl-4 heading-5">Logout</p>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showSmallDialog" class="dialogFullScreen bg-white card">
      <GlobalSearchMobile @closePopup="closePopup"/>
    </div>
  </div>
</template>

<script>
import GlobalSearchMobile from '../../components/globalSearchMobile.vue'
import GlobalSearch from '../../components/globalSearch.vue'
import {removeCookies} from '@/utils/cookies'
export default {
  components: {
    GlobalSearch,
    GlobalSearchMobile
  },
  name: "leftNavbar",
  props: ["routesList"],
  data() {
    return {
      showSmallDialog: false,
      isOpennn: false,
      isOpen: false,
      EmpObj: [],
      isfavorite: false,
      setFavIcon: false,
      menu: false,
      color123: 'hsla(0, 0%, 100%, .33)',
      drawerIsOpen: false,
      showGlobalSearch: false,
      showDashboadMenus: false,
      showAddNewWorkMenus: false,
      showHistory: false,
      showAddFavorite: false,
      showAvtarMenu: false,
      mobileView: false,
      extraSmall: false,
      favoriteList: [],
      searchWidth: 200,
    };
  },
  created() {
    window.addEventListener("resize", this.resizeWindowHandler);
  },
  mounted() {
    this.searchWidth = window.innerWidth - 500
    let Isadmin =  JSON.parse(localStorage.getItem('employeeData1'))
    this.EmpObj = Isadmin
    this.resizeWindowHandler();
  },
  watch: {},
  methods: {
    showGlobalSearch1 (data) {
      console.log('DATTTTTTTTTTTTTTTTTTTTTTTTTTTT' ,data)
      this.showGlobalSearch = data
      if (!data) {
        this.color123 = 'hsla(0, 0%, 100%, .33)'
      } else {
        this.color123 = '#FFF'
      }
    },
    openDialog1() {
      this.showSmallDialog = true
    },
    closePopup () {
      document.body.style = 'overflow: visible;'
      this.showSmallDialog = false
    },
    smallViewOpenDrawer2() {
      this.$root.$emit('openDialog', true)
    },
    smallViewOpenDrawer() {
      this.isOpennn = !this.isOpennn
      // this.$root.$emit('openDialog', this.isOpennn)
      this.$root.$emit('openDialog', true)
    },
    isOpenValue () {
      console.log('open value')
      this.isOpen = !this.isOpen
    },
    onClickOutside () {
      console.log('Close value', this.isOpen)
      this.isOpen = false
    },
    LogOut () {
      removeCookies('authToken')
      localStorage.clear()
      this.$router.push({name: 'login'})
      location.reload()
    },
    resizeWindowHandler() {
      if (window.innerWidth < 1024) {
        this.mobileView = true;
      } else {
        this.mobileView = false;
      }
      if (window.innerWidth < 662) {
        this.extraSmall = true;
      } else {
        this.extraSmall = false;
      }
      this.searchWidth = window.innerWidth - 700
    },
    beforeDestroy() {
  },
  },
};
</script>
<style scoped>
.menu_iconss {
  width: inherit;
  padding: 0px 0px 0px 0px;
  display: inherit;
  align-items: center;
}
.row_user_svg {
  height: 25px;
  width: 25px;
}
.dialogFullScreen {
  position: fixed;
  height: 100%;
  width: 100%;
  min-width: 80px;
  z-index: 400 !important;
  top: 0;
  overflow-x: hidden;
  transition: 0.5s;
  border-radius: 0px !important;
  right: 0;
}
</style>